module.exports = __webpack_public_path__ + "img/29_35.ba8e6b4e.png";